import { render, staticRenderFns } from "./mealTab.vue?vue&type=template&id=4c887aa4&scoped=true&"
import script from "./mealTab.vue?vue&type=script&lang=js&"
export * from "./mealTab.vue?vue&type=script&lang=js&"
import style0 from "./mealTab.vue?vue&type=style&index=0&id=4c887aa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c887aa4",
  null
  
)

export default component.exports